"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadGarages = loadGarages;
var GARAGES_LOAD = exports.GARAGES_LOAD = "GARAGES_LOAD";

function loadGarages() {
  var rawGarages = globalVariables.InitData.Companies;
  var garages = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rawGarages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var garage = _step.value;
      garages[garage.Id] = garage;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {
    type: GARAGES_LOAD,
    garages: garages
  };
}